import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Spring Behavioral Health of New Jersey theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const SPRINGBHNJ_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/springbhnj/logo.png",
        alt: "Spring Behavioral Health of New Jersey Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 32,
  state: "NJ",
  departmentIds: [145, 160],
};
